/* NutriFitt x Lee Priest - Holy Water product page.
   Interactive layer: touchable water on the hero (WebGL, draws only while something moves), drag blade, supply planner,
   tilt + magnet on desktop, chapter rail, swipeable viewer, fly-to-cart. One file, no libraries. */
(function () {
  var root = document.querySelector('[data-hw]');
  if (!root) return;
  root.classList.remove('no-js');
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var q = function (s, el) { return (el || root).querySelector(s); };
  var qa = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var buzz = function (p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} };
  var fmt = root.getAttribute('data-money') || '${{amount}}';
  function money(c) {
    var v = (Number(c) || 0) / 100, s = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  var data = {};
  try { data = JSON.parse(q('[data-hw-json]').textContent); } catch (e) {}
  var variants = data.variants || [];
  var servings = data.servings || 21;
  var state = { id: Number(q('[data-hw-id]').value), qty: 1 };
  var byId = function (id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === Number(id)) return variants[i]; return null; };
  var idxOf = function (id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === Number(id)) return i; return 0; };
  var TONES = { blue: [0.25, 0.66, 1.0], red: [1.0, 0.17, 0.27] };

  /* ---------- touchable water (WebGL) ---------- */
  var stage = q('[data-hw-stage]'), arch = q('[data-hw-arch]');
  function Water() {
    var cv = document.createElement('canvas'); cv.className = 'hw-gl'; cv.setAttribute('aria-hidden', 'true');
    var gl = null;
    try { gl = cv.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, premultipliedAlpha: false, preserveDrawingBuffer: false, powerPreference: 'low-power' }); } catch (e) {}
    if (!gl) return null;
    var VS = 'attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
    var FS = 'precision mediump float;uniform sampler2D A,B;uniform vec2 SA,SB,WC,PX;uniform float ASP,WIPE;uniform vec4 R[8];uniform vec3 TONE;varying vec2 v;'
      + 'float wv(vec2 p,vec4 r){vec2 d=p-r.xy;d.x*=ASP;float x=length(d)-r.z*.36;return sin(x*95.)*exp(-x*x*320.)*exp(-r.z*1.7)*r.w;}'
      + 'float H(vec2 p){float s=0.;for(int i=0;i<8;i++){s+=wv(p,R[i]);}return s;}'
      + 'void main(){float h0=H(v);vec2 g=vec2(H(v+vec2(PX.x,0.))-h0,H(v+vec2(0.,PX.y))-h0)*10.;vec2 uv=v+g*.018;'
      + 'vec3 a=texture2D(A,(uv-.5)*SA+.5).rgb;vec3 b=texture2D(B,(uv-.5)*SB+.5).rgb;'
      + 'vec2 dw=uv-WC;dw.x*=ASP;float dl=length(dw);float m=1.-smoothstep(WIPE-.04,WIPE,dl);'
      + 'vec3 c=mix(a,b,m);float rim=exp(-pow((dl-WIPE)*30.,2.))*step(.002,WIPE);c+=TONE*rim*.6;'
      + 'vec3 N=normalize(vec3(-g*3.,1.));float sp=pow(max(dot(N,normalize(vec3(-.35,-.55,1.))),0.),48.);'
      + 'c+=vec3(sp)*.5+TONE*abs(h0)*.4;gl_FragColor=vec4(c,1.);}';
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
    var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return null;
    var pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return null;
    gl.useProgram(pr);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var ap = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(ap); gl.vertexAttribPointer(ap, 2, gl.FLOAT, false, 0, 0);
    var U = {}; ['A', 'B', 'SA', 'SB', 'WC', 'PX', 'ASP', 'WIPE', 'R', 'TONE'].forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    gl.uniform1i(U.A, 0); gl.uniform1i(U.B, 1);
    var coarse = !fine, dpr = coarse ? 1 : Math.min(window.devicePixelRatio || 1, 1.5);
    var W = 2, Hh = 2, asp = 0.75, texA = null, texB = null, arA = 0.75, arB = 0.75, cache = {};
    var rip = [], wipe = -1, wc = [0.5, 0.5], tone = TONES.blue, raf = 0, last = 0, live = true, ready = false;
    var R = new Float32Array(32);
    function cover(ar) { return ar > asp ? [asp / ar, 1] : [1, ar / asp]; }
    function load(url, cb) {
      if (cache[url]) { if (cache[url].t) cb(cache[url]); else cache[url].q.push(cb); return; }
      var rec = cache[url] = { t: null, ar: 0.75, q: [cb] };
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () {
        var t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, im); } catch (e) { return; }
        rec.t = t; rec.ar = im.naturalWidth / im.naturalHeight; rec.q.forEach(function (f) { f(rec); }); rec.q = [];
      };
      im.src = url;
    }
    function size() {
      var w = arch.clientWidth, h = arch.clientHeight; if (!w || !h) return;
      W = Math.round(w * dpr); Hh = Math.round(h * dpr); asp = w / h;
      if (cv.width !== W || cv.height !== Hh) { cv.width = W; cv.height = Hh; gl.viewport(0, 0, W, Hh); }
      draw();
    }
    function draw() {
      if (!ready) return;
      for (var i = 0; i < 8; i++) { var r = rip[i]; var o = i * 4; if (r) { R[o] = r.x; R[o + 1] = r.y; R[o + 2] = r.t; R[o + 3] = r.a; } else { R[o + 3] = 0; } }
      gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, texA);
      gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, texB || texA);
      var sa = cover(arA), sb = cover(arB);
      gl.uniform2f(U.SA, sa[0], sa[1]); gl.uniform2f(U.SB, sb[0], sb[1]);
      gl.uniform2f(U.WC, wc[0], wc[1]); gl.uniform2f(U.PX, 1.5 / W, 1.5 / Hh);
      gl.uniform1f(U.ASP, asp); gl.uniform1f(U.WIPE, wipe < 0 ? 0 : wipe);
      gl.uniform4fv(U.R, R); gl.uniform3f(U.TONE, tone[0], tone[1], tone[2]);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    function frame(now) {
      raf = 0;
      if (coarse && last && now - last < 30) { raf = requestAnimationFrame(frame); return; }
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 0.016; last = now;
      for (var i = rip.length - 1; i >= 0; i--) { rip[i].t += dt; if (rip[i].t > 2.4) rip.splice(i, 1); }
      if (wipe >= 0) { wipe += dt * 1.25; if (wipe > 1.7) { texA = texB; arA = arB; wipe = -1; } }
      draw();
      if (live && (rip.length || wipe >= 0)) raf = requestAnimationFrame(frame); else last = 0;
    }
    function wake() { if (!raf && ready && live && !document.hidden) { last = 0; raf = requestAnimationFrame(frame); } }
    var api = {
      spawn: function (x, y, a) { if (!ready || !live || reduced) return; rip.push({ x: x, y: y, t: 0, a: a }); if (rip.length > 8) rip.shift(); wake(); },
      show: function (url, x, y) {
        if (!url) return;
        load(url, function (rec) {
          if (rec.t === texA && wipe < 0) return;
          if (wipe >= 0) { texA = texB; arA = arB; }
          texB = rec.t; arB = rec.ar; wc = [x, y];
          if (reduced) { texA = texB; arA = arB; wipe = -1; draw(); return; }
          wipe = 0; api.spawn(x, y, 1.3); wake();
        });
      },
      tone: function (t) { tone = TONES[t] || tone; if (!raf) draw(); },
      setLive: function (on) { live = on; if (on) wake(); },
      on: function () { return ready; }
    };
    cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); ready = false; arch.classList.remove('hw-gl-on'); });
    var rays = q('.hw-rays', arch); arch.insertBefore(cv, rays);
    load(data.scene, function (rec) {
      texA = texB = rec.t; arA = arB = rec.ar; ready = true; size();
      requestAnimationFrame(function () { arch.classList.add('hw-gl-on'); });
    });
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(arch); else addEventListener('resize', size);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) wake(); });
    return api;
  }
  var water = (stage && arch && !reduced) ? Water() : null;
  var hint = q('[data-hw-touch]');
  var used = function () { if (hint) hint.classList.add('is-used'); };
  function ring(x, y) {
    if (reduced) return;
    var r = document.createElement('span'); r.className = 'hw-ring'; r.style.left = (x * 100) + '%'; r.style.top = (y * 100) + '%';
    arch.appendChild(r); setTimeout(function () { r.remove(); }, 1100);
  }
  if (stage && arch) {
    var lx = -1, ly = -1, lt = 0, down = false;
    var rel = function (e) { var r = arch.getBoundingClientRect(); return [clamp((e.clientX - r.left) / r.width, 0, 1), clamp((e.clientY - r.top) / r.height, 0, 1)]; };
    stage.addEventListener('pointerdown', function (e) {
      down = true; var p = rel(e); used(); buzz(8);
      if (water && water.on()) water.spawn(p[0], p[1], 1.0); else ring(p[0], p[1]);
    });
    addEventListener('pointerup', function () { down = false; }, { passive: true });
    stage.addEventListener('pointermove', function (e) {
      var p = rel(e), now = performance.now();
      if (fine) {
        stage.style.setProperty('--ry', ((p[0] - 0.5) * 9).toFixed(2) + 'deg');
        stage.style.setProperty('--rx', ((0.5 - p[1]) * 7).toFixed(2) + 'deg');
        stage.style.setProperty('--px', ((p[0] - 0.5) * -14).toFixed(1) + 'px');
        stage.style.setProperty('--py', ((p[1] - 0.5) * -10).toFixed(1) + 'px');
      }
      if ((fine || down) && water && now - lt > 70 && (Math.abs(p[0] - lx) + Math.abs(p[1] - ly)) > 0.035) {
        lt = now; lx = p[0]; ly = p[1]; used(); water.spawn(p[0], p[1], fine ? 0.32 : 0.45);
      }
    }, { passive: true });
    stage.addEventListener('pointerleave', function () { ['--rx', '--ry', '--px', '--py'].forEach(function (k) { stage.style.removeProperty(k); }); });
    /* falling drops ripple where they land */
    qa('[data-hw-ripple]', arch).forEach(function (d) {
      d.addEventListener('animationiteration', function () { if (water && water.on()) water.spawn((d.offsetLeft + 2) / arch.clientWidth, 0.86, 0.5); });
    });
  }
  /* hero glow follows the pointer */
  var hero = q('.hw-hero'), glow = q('[data-hw-glow]');
  if (fine && hero && glow && !reduced) hero.addEventListener('pointermove', function (e) {
    var r = hero.getBoundingClientRect(); glow.style.setProperty('--gx', (e.clientX - r.left) + 'px'); glow.style.setProperty('--gy', (e.clientY - r.top) + 'px');
  }, { passive: true });

  /* ---------- buy state ---------- */
  var PACKNAME = { 1: 'Single tub', 3: '3-pack', 5: '5-pack' };
  function render(origin) {
    var v = byId(state.id); if (!v) return;
    qa('[data-hw-price]').forEach(function (el) { var t = money(v.price * state.qty); if (el.textContent !== t) { el.textContent = t; if (!reduced) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); } } });
    if (typeof syncTwins === 'function') syncTwins(v.id);
    qa('[data-hw-per]').forEach(function (el) { el.textContent = money(Math.round(v.price / servings)) + ' / serving'; });
    qa('[data-hw-pack-price]').forEach(function (el) { el.textContent = money(v.price * Number(el.getAttribute('data-hw-pack-price'))); });
    qa('[data-hw-flavor-name]').forEach(function (el) { el.textContent = v.name; });
    qa('[data-hw-pack-name]').forEach(function (el) { el.textContent = PACKNAME[state.qty] || state.qty + ' tubs'; });
    root.setAttribute('data-tone', v.tone);
    q('[data-hw-id]').value = v.id; q('[data-hw-qty]').value = state.qty;
    var add = q('[data-hw-add]'); if (add) add.disabled = !v.available;
    var sel = q('[data-hw-sticky-flavor]'); if (sel) sel.value = String(v.id);
    var pairSel = q('[data-hw-pair-hw]'); if (pairSel && pairSel.value !== String(v.id)) { pairSel.value = String(v.id); pairTotal(); }
    var sImg = q('[data-hw-sticky-img]'); if (sImg && v.thumb) sImg.src = v.thumb;
    if (origin !== 'init') {
      qa('[data-hw-stage-img]').forEach(function (img) { img.classList.toggle('is-on', img.getAttribute('data-hw-stage-img') === String(v.id)); });
      if (water) { water.tone(v.tone); water.show(v.gl, idxOf(v.id) ? 0.78 : 0.22, 0.9); }
    }
    calcR();
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
  }
  function pick(id, scroll) {
    var inp = q('input[name="hw-flavor"][value="' + id + '"]');
    if (inp && !inp.disabled) inp.checked = true;
    if (Number(id) !== state.id) buzz(10);
    state.id = Number(id); render();
    if (scroll) { var b = q('[data-hw-buy]'); if (b) b.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }
  }
  function setPack(n) {
    var r = q('input[name="hw-pack"][value="' + n + '"]'); if (r) r.checked = true;
    state.qty = Number(n) || 1; render('pack');
  }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'hw-flavor') pick(t.value);
    else if (t.name === 'hw-pack') { state.qty = Number(t.value) || 1; render('pack'); }
    else if (t.hasAttribute('data-hw-sticky-flavor')) pick(t.value);
    else if (t.hasAttribute('data-hw-pair-cr') || t.hasAttribute('data-hw-pair-hw')) pairTotal();
    else if (t.name === 'hw-weeks') calcR();
  });
  qa('[data-hw-choose]').forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-hw-choose'), true); }); });

  /* ---------- cart ---------- */
  function cartIcon() {
    var c = qa('header a[href="/cart"], header .cart-link, .site-header a[href="/cart"], a[href="/cart"]', document).filter(function (a) { var r = a.getBoundingClientRect(); return r.width > 0 && r.top >= 0 && r.top < innerHeight; });
    return c[0] || null;
  }
  function fly(from) {
    if (reduced || !from || !document.body.animate) return;
    var to = cartIcon(); if (!to) return;
    var a = from.getBoundingClientRect(), b = to.getBoundingClientRect();
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var acc = getComputedStyle(root).getPropertyValue('--acc').trim() || '#3fa9ff';
    var d = document.createElement('span'); d.className = 'hw-fly';
    d.style.background = 'radial-gradient(circle at 35% 30%, #fff, ' + acc + ' 45%, #02060c)'; d.style.boxShadow = '0 0 18px ' + acc;
    document.body.appendChild(d);
    var mx = (x0 + x1) / 2, my = Math.min(y0, y1) - 140;
    d.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1.2)', opacity: 1 },
      { transform: 'translate(' + mx + 'px,' + my + 'px) scale(1)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.35)', opacity: 0.2 }
    ], { duration: 900, easing: 'cubic-bezier(.3,.6,.2,1)' }).onfinish = function () { d.remove(); to.classList.remove('hw-bump'); void to.offsetWidth; to.classList.add('hw-bump'); };
  }
  function addItems(items) {
    return fetch(root.getAttribute('data-add-url'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart. Try again.'); return j; }); })
      .then(function (j) {
        document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          qa('[data-cart-count], .cart-link__count, .cart-count, [data-header-cart-count]', document).forEach(function (el) { el.textContent = c.item_count; });
          ['cart:refresh', 'cart:updated', 'theme:cart:change'].forEach(function (n) { try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: c } })); } catch (e) {} });
          setTimeout(function () { if (window.theme && theme.settings && theme.settings.cart_type === 'drawer') document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true })); }, 700);
          return j;
        }).catch(function () { return j; });
      });
  }
  function busy(btn, status, items, done) {
    if (!btn || btn.classList.contains('is-busy')) return;
    var lab = btn.querySelector('span'), before = lab ? lab.textContent : '';
    btn.classList.add('is-busy'); if (lab) lab.textContent = 'Blessing...'; if (status) status.textContent = '';
    addItems(items).then(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-sheen'); if (lab) lab.textContent = done;
      fly(btn); buzz([14, 40, 22]);
      if (water && water.on()) { water.spawn(0.5, 0.55, 1.4); setTimeout(function () { water.spawn(0.5, 0.55, 0.8); }, 220); }
      if (status) status.innerHTML = 'Blessed and in your cart. <a href="/cart">View cart</a> &middot; <a href="/checkout">Checkout</a>';
      setTimeout(function () { btn.classList.remove('is-sheen'); if (lab) lab.textContent = before; }, 2600);
    }).catch(function (err) { btn.classList.remove('is-busy'); if (lab) lab.textContent = before; if (status) status.textContent = err.message; });
  }
  var form = q('[data-hw-form]'), addBtn = q('[data-hw-add]');
  /* button, not submit: the theme's own cart script listens for product-form submits */
  if (addBtn) { addBtn.type = 'button'; addBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); busy(addBtn, q('[data-hw-status]'), [{ id: state.id, quantity: state.qty }], 'In your cart'); }); }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); if (addBtn) addBtn.click(); }, true);
  var sAdd = q('[data-hw-sticky-add]');
  if (sAdd) sAdd.addEventListener('click', function () { busy(sAdd, q('[data-hw-status]'), [{ id: state.id, quantity: state.qty }], 'Added'); });

  /* ---------- Chapter I + II ---------- */
  function pairTotal() {
    var a = q('[data-hw-pair-cr]'), b = q('[data-hw-pair-hw]'), out = q('[data-hw-pair-total]');
    if (!a || !b || !out) return;
    out.textContent = money(Number(a.options[a.selectedIndex].getAttribute('data-cents')) + Number(b.options[b.selectedIndex].getAttribute('data-cents')));
  }
  var pairBtn = q('[data-hw-pair-add]');
  if (pairBtn) pairBtn.addEventListener('click', function () {
    busy(pairBtn, q('[data-hw-pair-status]'), [{ id: Number(q('[data-hw-pair-cr]').value), quantity: 1 }, { id: Number(q('[data-hw-pair-hw]').value), quantity: 1 }], 'Both in your cart');
  });
  pairTotal();

  /* ---------- supply planner ---------- */
  var calc = q('[data-hw-calc]'), days = q('[data-hw-days]'), calcPack = 3;
  function calcR() {
    if (!calc || !days) return;
    var v = byId(state.id); if (!v) return;
    var d = Number(days.value) || 5, wEl = q('input[name="hw-weeks"]:checked', calc), w = wEl ? Number(wEl.value) : 8;
    var per = servings / d, tubs = Math.ceil(w * d / servings), pack = tubs <= 1 ? 1 : (tubs <= 3 ? 3 : 5), cover = Math.floor(pack * servings / d);
    calcPack = pack;
    days.style.setProperty('--p', ((d - 2) / 5 * 100) + '%');
    q('[data-hw-days-out]', calc).textContent = d;
    q('[data-hw-calc-weeks]', calc).textContent = per.toFixed(1);
    q('[data-hw-calc-bar]', calc).style.setProperty('--w', clamp(per / 10.5 * 100, 8, 100) + '%');
    q('[data-hw-calc-line]', calc).textContent = 'For ' + w + ' weeks at ' + d + ' sessions a week you will go through ' + tubs + (tubs === 1 ? ' tub.' : ' tubs.');
    q('[data-hw-calc-rec]', calc).textContent = pack === 1 ? 'One tub covers you' : (tubs > 5 ? 'The 5-pack covers ' + cover + ' weeks, then restock' : 'The ' + pack + '-pack covers ' + cover + ' weeks');
    q('[data-hw-calc-price]', calc).textContent = money(v.price * pack);
    var lab = q('[data-hw-calc-add] span', calc); if (lab && !q('[data-hw-calc-add]', calc).classList.contains('is-busy')) lab.textContent = pack === 1 ? 'Add 1 tub' : 'Add the ' + pack + '-pack';
  }
  if (calc && days) {
    days.addEventListener('input', function () { calcR(); buzz(4); });
    var cAdd = q('[data-hw-calc-add]', calc);
    if (cAdd) cAdd.addEventListener('click', function () { busy(cAdd, q('[data-hw-calc-status]', calc), [{ id: state.id, quantity: calcPack }], 'Covered'); });
    var cLock = q('[data-hw-calc-lock]', calc);
    if (cLock) cLock.addEventListener('click', function () { setPack(calcPack); var b = q('[data-hw-buy]'); if (b) b.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); });
  }

  /* ---------- ingredient notes ---------- */
  qa('.hw-ing').forEach(function (b) { b.addEventListener('click', function () {
    var open = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var n = b.nextElementSibling; if (n) n.hidden = !open; buzz(5);
  }); });

  /* ---------- drag blade ---------- */
  var cmp = q('[data-hw-cmp]');
  if (cmp) {
    var rng = q('[data-hw-cmp-range]', cmp), dragging = false;
    var setS = function (p) {
      p = clamp(p, 2, 98); cmp.style.setProperty('--split', p + '%');
      cmp.style.setProperty('--la', clamp((p - 16) / 24, 0, 1).toFixed(2)); cmp.style.setProperty('--lb', clamp((84 - p) / 24, 0, 1).toFixed(2));
      if (rng) rng.value = Math.round(p);
    };
    var mv = function (e) { var r = cmp.getBoundingClientRect(); setS((e.clientX - r.left) / r.width * 100); };
    cmp.addEventListener('pointerdown', function (e) { dragging = true; cmp.classList.add('is-drag'); try { cmp.setPointerCapture(e.pointerId); } catch (x) {} mv(e); buzz(6); });
    cmp.addEventListener('pointermove', function (e) { if (dragging) mv(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { cmp.addEventListener(n, function () { dragging = false; cmp.classList.remove('is-drag'); }); });
    if (rng) rng.addEventListener('input', function () { setS(Number(rng.value)); });
    cmp._hint = function () {
      if (reduced) return; var t0 = 0;
      var step = function (t) { if (dragging) return; if (!t0) t0 = t; var k = (t - t0) / 1900; if (k >= 1) { setS(50); return; } setS(50 + Math.sin(k * Math.PI * 2) * 24 * (1 - k)); requestAnimationFrame(step); };
      requestAnimationFrame(step);
    };
  }

  /* ---------- tilt + magnet + shine (desktop) ---------- */
  if (fine && !reduced) {
    qa('[data-hw-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--try', ((x - 0.5) * 8).toFixed(2) + 'deg'); el.style.setProperty('--trx', ((0.5 - y) * 6).toFixed(2) + 'deg');
        el.style.setProperty('--sx', (x * 100).toFixed(1) + '%'); el.style.setProperty('--sy', (y * 100).toFixed(1) + '%'); el.style.setProperty('--so', '1');
      }, { passive: true });
      el.addEventListener('pointerleave', function () { ['--try', '--trx', '--so'].forEach(function (k) { el.style.removeProperty(k); }); });
    });
    qa('[data-hw-magnet]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.translate = ((e.clientX - r.left - r.width / 2) * 0.08).toFixed(1) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.25).toFixed(1) + 'px'; }, { passive: true });
      b.addEventListener('pointerleave', function () { b.style.translate = ''; });
    });
  }

  /* ---------- story: words land one by one ---------- */
  qa('[data-hw-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/); el.textContent = '';
    words.forEach(function (w, i) { var s = document.createElement('span'); s.className = 'hw-w'; s.style.setProperty('--i', i); s.textContent = w; el.appendChild(s); if (i < words.length - 1) el.appendChild(document.createTextNode(' ')); });
  });

  /* ---------- gallery: drag (mouse) + viewer with swipe ---------- */
  var gal = q('[data-hw-drag]');
  if (gal && fine) {
    var gx = 0, gs = 0, gd = false, moved = 0;
    gal.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; gd = true; moved = 0; gx = e.clientX; gs = gal.scrollLeft; });
    addEventListener('pointermove', function (e) { if (!gd) return; var dx = e.clientX - gx; moved = Math.max(moved, Math.abs(dx)); if (moved > 6) gal.classList.add('is-drag'); gal.scrollLeft = gs - dx; }, { passive: true });
    addEventListener('pointerup', function () { if (!gd) return; gd = false; setTimeout(function () { gal.classList.remove('is-drag'); }, 30); });
  }
  var lb = q('[data-hw-lb]'), items = qa('[data-hw-gal]'), li = 0;
  function lbShow(i) {
    if (!lb || !items.length) return; li = (i + items.length) % items.length;
    var b = items[li], img = q('[data-hw-dialog-img]', lb);
    img.src = b.getAttribute('data-hw-src'); img.alt = b.getAttribute('data-hw-alt') || '';
    q('[data-hw-lb-count]', lb).textContent = (li + 1) + ' / ' + items.length; q('[data-hw-lb-cap]', lb).textContent = img.alt;
  }
  items.forEach(function (b, i) { b.addEventListener('click', function () { lbShow(i); if (lb.showModal) lb.showModal(); else lb.setAttribute('open', ''); }); });
  if (lb) {
    qa('[data-hw-lb-go]', lb).forEach(function (b) { b.addEventListener('click', function () { lbShow(li + Number(b.getAttribute('data-hw-lb-go'))); }); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') lbShow(li + 1); if (e.key === 'ArrowLeft') lbShow(li - 1); });
    var sx0 = null; var body = q('.hw-lb__body', lb);
    body.addEventListener('pointerdown', function (e) { sx0 = e.clientX; });
    body.addEventListener('pointerup', function (e) { if (sx0 === null) return; var dx = e.clientX - sx0; sx0 = null; if (Math.abs(dx) > 50) lbShow(li + (dx < 0 ? 1 : -1)); });
  }
  qa('[data-hw-open]').forEach(function (b) { b.addEventListener('click', function () {
    var d = document.getElementById(b.getAttribute('data-hw-open')); if (!d) return;
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  }); });
  function shut(d) {
    if (d.classList.contains('is-closing')) return;
    var done = function () { d.classList.remove('is-closing', 'is-opening'); if (d.close) d.close(); else d.removeAttribute('open'); };
    if (reduced) { done(); return; }
    d.classList.add('is-closing'); setTimeout(done, 380);
  }
  qa('.hw-dialog').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-hw-close]')) shut(d); });
    d.addEventListener('cancel', function (e) { e.preventDefault(); shut(d); });
  });

  /* ---------- reveals, counters, rail, motion pause, sticky ---------- */
  function count(el) {
    var to = parseFloat(el.getAttribute('data-hw-count')), dec = (String(to).split('.')[1] || '').length, t0 = 0;
    if (reduced) { el.textContent = to.toFixed(dec); return; }
    function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 3); el.textContent = (to * e).toFixed(dec); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in'); io.unobserve(en.target);
      qa('[data-hw-count]', en.target).forEach(count);
      if (en.target === cmp && cmp._hint) setTimeout(cmp._hint, 500);
    }); }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    qa('[data-hw-reveal]').forEach(function (el) { io.observe(el); });
    var liveIO = new IntersectionObserver(function (es) { es.forEach(function (en) {
      en.target.classList.toggle('is-off', !en.isIntersecting);
      if (en.target === stage && water) water.setLive(en.isIntersecting);
    }); });
    qa('[data-hw-live]').forEach(function (el) { liveIO.observe(el); });
    var rail = q('[data-hw-rail]');
    if (rail) {
      var links = qa('a', rail);
      var chIO = new IntersectionObserver(function (es) { es.forEach(function (en) {
        if (!en.isIntersecting) return; var k = en.target.getAttribute('data-hw-chapter');
        links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('data-hw-rail-for') === k); });
      }); }, { rootMargin: '-45% 0px -50% 0px' });
      qa('[data-hw-chapter]').forEach(function (s) { chIO.observe(s); });
      var endIO = new IntersectionObserver(function (es) { rail.classList.toggle('is-off', es[0].isIntersecting); });
      var rec = document.querySelector('.product-recommendations, #shopify-section-reviews, .jdgm-review-widget'); if (rec) endIO.observe(rec);
      links.forEach(function (a) { a.addEventListener('click', function (e) { var t = document.querySelector(a.getAttribute('href')); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }); });
    }
    var sticky = q('[data-hw-sticky]'), foot = document.querySelector('footer, .section-footer');
    if (sticky && addBtn) {
      var ctaVis = true, footVis = false;
      var set = function () { var on = !ctaVis && !footVis; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); qa('button, select', sticky).forEach(function (x) { x.tabIndex = on ? 0 : -1; }); };
      new IntersectionObserver(function (es) { ctaVis = es[0].isIntersecting || es[0].boundingClientRect.top > innerHeight; set(); }).observe(addBtn);
      if (foot) new IntersectionObserver(function (es) { footVis = es[0].isIntersecting; set(); }).observe(foot);
    }
  } else { qa('[data-hw-reveal]').forEach(function (el) { el.classList.add('is-in'); }); qa('[data-hw-count]').forEach(count); }

  /* ---------- hw-facts viewer: opens zoomed on the label's facts panel; drag, pinch, double-tap, wheel ---------- */
  var fd = q('[data-hw-facts]');
  if (fd) {
    /* preload the label so the pop-up never opens empty */
    var warm = function () { qa('[data-hw-facts-img]', fd).forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); }); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 }); else setTimeout(warm, 1500);
    qa('[data-hw-facts-open]').forEach(function (b) { b.addEventListener('pointerenter', warm, { once: true }); b.addEventListener('touchstart', warm, { once: true, passive: true }); });
    var fview = q('[data-hw-facts-view]', fd), fimgs = qa('[data-hw-facts-img]', fd), ftabs = qa('[data-hw-facts-tab]', fd), fz = q('[data-hw-facts-z]', fd), ffull = q('[data-hw-facts-full]', fd);
    /* where the Supplement Facts panel sits on the label render (fractions of the image) */
    var PX = 0.5, PY = 0.5, PH = 1, Z = 1, ix = 0, iy = 0, ptrs = {}, pinch = null, drag = null, lastTap = 0, lastX = 0, lastY = 0;
    var base = function () { var vw = fview.clientWidth, vh = fview.clientHeight; return { vw: vw, vh: vh, w: Math.min(vw * 0.96, (vh * 0.96) / (PH * 4 / 3)) }; };
    var apply = function () {
      var b = base(), w = b.w * Z, h = w * 4 / 3;
      ix = w <= b.vw ? (b.vw - w) / 2 : clamp(ix, b.vw - w, 0); iy = h <= b.vh ? (b.vh - h) / 2 : clamp(iy, b.vh - h, 0);
      fview.style.setProperty('--iw', w.toFixed(1) + 'px'); fview.style.setProperty('--ix', ix.toFixed(1) + 'px'); fview.style.setProperty('--iy', iy.toFixed(1) + 'px');
      if (fz) fz.textContent = (Math.round(Z * 10) / 10) + '\u00d7';
    };
    var center = function () { var b = base(), w = b.w * Z, h = w * 4 / 3; ix = b.vw / 2 - PX * w; iy = b.vh / 2 - PY * h; apply(); };
    var zoomAt = function (z, cx, cy) {
      var b = base(), w0 = b.w * Z, px = (cx - ix) / w0, py = (cy - iy) / (w0 * 4 / 3);
      Z = clamp(z, 1, 4); var w = b.w * Z; ix = cx - px * w; iy = cy - py * w * 4 / 3; apply();
    };
    var tab = function (i) {
      fimgs.forEach(function (im) { im.hidden = im.getAttribute('data-hw-facts-img') !== String(i); });
      ftabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-hw-facts-tab') === String(i) ? 'true' : 'false'); });
      var im = fimgs[i] || fimgs[0]; if (ffull && im) ffull.href = im.currentSrc || im.src;
    };
    ftabs.forEach(function (t) { t.addEventListener('click', function () { tab(Number(t.getAttribute('data-hw-facts-tab'))); Z = 1; center(); buzz(6); }); });
    qa('[data-hw-facts-open]').forEach(function (b) { b.addEventListener('click', function () {
      var v = byId(state.id), want = 0;
      ftabs.forEach(function (t) { if (v && t.getAttribute('data-tone') === v.tone) want = Number(t.getAttribute('data-hw-facts-tab')); });
      fimgs.forEach(function (im) { im.loading = 'eager'; });
      tab(want);
      if (fd.showModal) fd.showModal(); else fd.setAttribute('open', '');
      var br = b.getBoundingClientRect(), dr = fd.getBoundingClientRect();
      fd.style.setProperty('--ox', Math.round(br.left + br.width / 2 - dr.left) + 'px');
      fd.style.setProperty('--oy', Math.round(br.top + br.height / 2 - dr.top) + 'px');
      fd.classList.remove('is-closing'); fd.classList.remove('is-opening'); void fd.offsetWidth; fd.classList.add('is-opening');
      Z = 1; requestAnimationFrame(function () { fview.classList.add('is-drag'); center(); requestAnimationFrame(function () { fview.classList.remove('is-drag'); }); });
      buzz(8);
    }); });
    var local = function (e) { var r = fview.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    fview.addEventListener('pointerdown', function (e) {
      try { fview.setPointerCapture(e.pointerId); } catch (x) {}
      ptrs[e.pointerId] = local(e); var ids = Object.keys(ptrs);
      if (ids.length === 2) { var a = ptrs[ids[0]], b = ptrs[ids[1]]; pinch = { d: Math.hypot(a[0] - b[0], a[1] - b[1]), z: Z }; drag = null; }
      else { drag = { x: ptrs[e.pointerId][0], y: ptrs[e.pointerId][1], ix: ix, iy: iy, moved: 0 }; fview.classList.add('is-drag'); }
    });
    fview.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return; ptrs[e.pointerId] = local(e); var ids = Object.keys(ptrs);
      if (pinch && ids.length === 2) { var a = ptrs[ids[0]], b = ptrs[ids[1]]; var d = Math.hypot(a[0] - b[0], a[1] - b[1]); fview.classList.add('is-drag'); zoomAt(pinch.z * d / pinch.d, (a[0] + b[0]) / 2, (a[1] + b[1]) / 2); return; }
      if (drag) { var p = ptrs[e.pointerId]; drag.moved = Math.max(drag.moved, Math.abs(p[0] - drag.x) + Math.abs(p[1] - drag.y)); ix = drag.ix + p[0] - drag.x; iy = drag.iy + p[1] - drag.y; apply(); }
    });
    var up = function (e) {
      var p = ptrs[e.pointerId]; delete ptrs[e.pointerId];
      if (Object.keys(ptrs).length < 2) pinch = null;
      if (drag && p && drag.moved < 8) {
        var now = performance.now();
        if (now - lastTap < 300 && Math.abs(p[0] - lastX) < 30 && Math.abs(p[1] - lastY) < 30) { zoomAt(Z < 1.9 ? 2 : (Z < 2.9 ? 3 : 1), p[0], p[1]); lastTap = 0; buzz(6); }
        else { lastTap = now; lastX = p[0]; lastY = p[1]; }
      }
      if (!Object.keys(ptrs).length) { drag = null; fview.classList.remove('is-drag'); }
    };
    ['pointerup', 'pointercancel'].forEach(function (n) { fview.addEventListener(n, up); });
    fview.addEventListener('wheel', function (e) { e.preventDefault(); var p = local(e); zoomAt(Z * (e.deltaY < 0 ? 1.15 : 0.87), p[0], p[1]); }, { passive: false });
    addEventListener('resize', function () { if (fd.open) apply(); }, { passive: true });
  }

  /* ---------- twin reliquaries: tap or hold to pour, the full one is chosen ---------- */
  var twins = qa('[data-hw-twin]'), twinAfter = q('[data-hw-twins-after]'), anyChosen = false;
  function twinSet(tw, f) { tw._f = f; var a = q('.hw-twin__arch', tw), r = q('.hw-twin__ringfill', tw); if (a) a.style.setProperty('--fill', f.toFixed(1)); if (r) r.style.strokeDashoffset = (100 - f).toFixed(1); }
  function twinAnim(tw, to, ms, done) {
    cancelAnimationFrame(tw._raf); var from = tw._f || 0, t0 = 0;
    if (reduced) { twinSet(tw, to); if (done) done(); return; }
    var step = function (t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / Math.max(1, ms)), e = to > from ? 1 - Math.pow(1 - k, 2) : k * k; twinSet(tw, from + (to - from) * e); if (k < 1) tw._raf = requestAnimationFrame(step); else if (done) done(); };
    tw._raf = requestAnimationFrame(step);
  }
  var LABEL = function (tw, t) { var l = q('[data-hw-twin-label]', tw); if (l) l.textContent = t; };
  function syncTwins(id) {
    if (!twins || !twins.length || !anyChosen) return;
    twins.forEach(function (t) {
      var me = t.getAttribute('data-hw-twin') === String(id);
      t.classList.toggle('is-chosen', me); t.classList.toggle('is-dim', !me); t.setAttribute('aria-pressed', me ? 'true' : 'false');
      LABEL(t, me ? 'Chosen' : 'Hold to pour');
      if (me && (t._f || 0) < 100) twinAnim(t, 100, 500); if (!me && (t._f || 0) > 0) twinAnim(t, 0, 450);
    });
  }
  function choose(tw) {
    var id = tw.getAttribute('data-hw-twin'); anyChosen = true;
    tw.classList.remove('is-pouring');
    buzz([12, 40, 18]);
    pick(id);
    syncTwins(Number(id));
    if (twinAfter) { twinAfter.classList.remove('is-ping'); void twinAfter.offsetWidth; twinAfter.classList.add('is-ping'); }
  }
  function pour(tw) {
    if (tw.disabled || tw.classList.contains('is-pouring')) return;
    if (tw.classList.contains('is-chosen')) { tw.classList.remove('is-chosen'); void tw.offsetWidth; tw.classList.add('is-chosen'); buzz(8); return; }
    tw.classList.add('is-pouring'); LABEL(tw, 'Pouring...'); buzz(6);
    twinAnim(tw, 100, 1000 * (1 - (tw._f || 0) / 100) + 150, function () { choose(tw); });
  }
  twins.forEach(function (tw) {
    twinSet(tw, 0);
    tw.addEventListener('pointerdown', function (e) { if (e.button > 0) return; tw._down = true; pour(tw); });
    tw.addEventListener('pointercancel', function () {
      /* the finger started scrolling: pour back out */
      if (!tw.classList.contains('is-pouring')) return;
      cancelAnimationFrame(tw._raf); tw.classList.remove('is-pouring'); LABEL(tw, 'Hold to pour'); twinAnim(tw, 0, 380);
    });
    tw.addEventListener('click', function (e) { if (e.detail === 0) pour(tw); });
  });
  var tAdd = q('[data-hw-twins-add]');
  if (tAdd) tAdd.addEventListener('click', function () { busy(tAdd, q('[data-hw-twins-status]'), [{ id: state.id, quantity: state.qty }], 'In your cart'); });

  /* drops fall the full stage height */
  var setFall = function () { if (stage) stage.style.setProperty('--fall', Math.round(stage.offsetHeight * 1.15) + 'px'); };
  setFall(); addEventListener('resize', setFall, { passive: true });

  /* first paint: the crypt stays unless the URL asked for a flavor */
  if (/[?&]variant=/.test(location.search)) render(); else { var v0 = byId(state.id); if (v0) { root.setAttribute('data-tone', v0.tone); if (water) water.tone(v0.tone); } calcR(); }
})();
